<template>
  <div v-if="isShow.isPOShow" class="po">
    <!--问题大赏 BEGIN-->
    <div
      class="poInner"
      :style="{ backgroundPositionY: jiqiDurBottom2 }"
      v-show="wendaState"
    >
      <!--太空服-->
      <div class="dttaikongren" :style="{ bottom: jiqiDurBottom }"></div>

      <!--机器光-->
      <div
        class="jiqiguang"
        :style="{ backgroundPositionY: jiqiDurBottom2 }"
      ></div>

      <!--机器屏幕-->
      <div class="jiqi-0" :style="{ backgroundPositionY: jiqiDurBottom2 }">
        <div
          class="jiqiqq jiqiqq1"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dotww1 + ')',
          }"
        ></div>
        <div
          class="jiqiqq jiqiqq2"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dotww2 + ')',
          }"
        ></div>
        <div
          class="jiqiqq jiqiqq3"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dotww3 + ')',
          }"
        ></div>
        <div
          class="jiqiqq jiqiqq4"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dotww4 + ')',
          }"
        ></div>
        <div
          class="jiqiqq jiqiqq5"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dotww5 + ')',
          }"
        ></div>
        <div
          class="jiqiqq jiqiqq6"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dotww6 + ')',
          }"
        ></div>
        <div
          class="jiqiqq jiqiqq7"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dotww7 + ')',
          }"
        ></div>
      </div>
      <div
        class="jiqi-1"
        :style="{ backgroundPositionY: jiqiDurBottom2 }"
        v-show="xingtuState"
      >
        <div
          class="jiqiwwInner"
          :style="{
            backgroundPositionY: jiqiDurBottom2,
            backgroundImage: 'url(' + dianSelectUrl2 + ')',
          }"
        ></div>
      </div>

      <!--答题框-->
      <div
        class="datikuang"
        :style="{ bottom: jiqiHeight }"
        v-show="questionkuangState"
      >
        <div class="dtkInner">
          <div class="dtkbg" :class="{ quanxidong: dtbgState }"></div>
          <div class="dtkzhuanbg" v-show="dtbgZhuanState"></div>

          <!--题目1 BEGIN-->
          <div class="question question1" v-show="question1State">
            <div class="questionInner" v-show="q1State">
              <!--选项 A BEGIN-->
              <div
                class="answer answerA"
                @click="chooiceQuestion1($event, 'A')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">A. 孔明灯</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 A END-->

              <!--选项 B BEGIN-->
              <div
                class="answer answerB"
                @click="chooiceQuestion1($event, 'B')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">B. 木鸢</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 B END-->

              <!--选项 C BEGIN-->
              <div
                class="answer answerC"
                @click="chooiceQuestion1($event, 'C')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">C. 热气球</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 C END-->

              <!--选项 D BEGIN-->
              <div
                class="answer answerD"
                @click="chooiceQuestion1($event, 'D')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">D. 飞机</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 D END-->
            </div>
          </div>
          <!--题目1 END-->

          <!--题目2 BEGIN-->
          <div class="question question2" v-show="question2State">
            <div class="questionInner" v-show="q2State">
              <!--选项 A BEGIN-->
              <div
                class="answer answerA"
                @click="chooiceQuestion2($event, 'A')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">A. 是</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 A END-->

              <!--选项 B BEGIN-->
              <div
                class="answer answerB"
                @click="chooiceQuestion2($event, 'B')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">B. 否</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 B END-->
            </div>
          </div>
          <!--题目2 END-->

          <!--题目3 BEGIN-->
          <div class="question question3" v-show="question3State">
            <div class="questionInner" v-show="q3State">
              <!--选项 A BEGIN-->
              <div
                class="answer answerA"
                @click="chooiceQuestion3($event, 'A')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">A. 太空外</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 A END-->

              <!--选项 B BEGIN-->
              <div
                class="answer answerB"
                @click="chooiceQuestion3($event, 'B')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">B. 火箭</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 B END-->

              <!--选项 C BEGIN-->
              <div
                class="answer answerC"
                @click="chooiceQuestion3($event, 'C')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">C. 空间站</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 C END-->

              <!--选项 D BEGIN-->
              <div
                class="answer answerD"
                @click="chooiceQuestion3($event, 'D')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">D. 太空飞船</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 D END-->
            </div>
          </div>
          <!--题目3 END-->

          <!--题目4 BEGIN-->
          <div class="question question4" v-show="question4State">
            <div class="questionInner" v-show="q4State">
              <!--选项 A BEGIN-->
              <div
                class="answer answerA"
                @click="chooiceQuestion4($event, 'A')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">A. “和平号”空间站</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 A END-->

              <!--选项 B BEGIN-->
              <div
                class="answer answerB"
                @click="chooiceQuestion4($event, 'B')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">B. “礼炮号”空间站</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 B END-->

              <!--选项 C BEGIN-->
              <div
                class="answer answerC"
                @click="chooiceQuestion4($event, 'C')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">C. 国际空间站</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 C END-->

              <!--选项 D BEGIN-->
              <div
                class="answer answerD"
                @click="chooiceQuestion4($event, 'D')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">D. 中国空间站</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 D END-->
            </div>
          </div>
          <!--题目4 END-->

          <!--题目5 BEGIN-->
          <div class="question question5" v-show="question5State">
            <div class="questionInner" v-show="q5State">
              <!--选项 A BEGIN-->
              <div
                class="answer answerA"
                @click="chooiceQuestion5($event, 'A')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">A. 最外层</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 A END-->

              <!--选项 B BEGIN-->
              <div
                class="answer answerB"
                @click="chooiceQuestion5($event, 'B')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">B. 最内层</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 B END-->

              <!--选项 C BEGIN-->
              <div
                class="answer answerC"
                @click="chooiceQuestion5($event, 'C')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">C. 第二层</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 C END-->

              <!--选项 D BEGIN-->
              <div
                class="answer answerD"
                @click="chooiceQuestion5($event, 'D')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">D. 第三层</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 D END-->
            </div>
          </div>
          <!--题目5 END-->

          <!--题目6 BEGIN-->
          <div class="question question6" v-show="question6State">
            <div class="questionInner" v-show="q6State">
              <!--选项 A BEGIN-->
              <div
                class="answer answerA"
                @click="chooiceQuestion6($event, 'A')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">A. 阿姆斯特朗</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 A END-->

              <!--选项 B BEGIN-->
              <div
                class="answer answerB"
                @click="chooiceQuestion6($event, 'B')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">B. 阿波罗</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 B END-->

              <!--选项 C BEGIN-->
              <div
                class="answer answerC"
                @click="chooiceQuestion6($event, 'C')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">C. 加加林</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 C END-->

              <!--选项 D BEGIN-->
              <div
                class="answer answerD"
                @click="chooiceQuestion6($event, 'D')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">D. 柯林斯</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 D END-->
            </div>
          </div>
          <!--题目6 END-->

          <!--题目7 BEGIN-->
          <div class="question question7" v-show="question7State">
            <div class="questionInner" v-show="q7State">
              <!--选项 A BEGIN-->
              <div
                class="answer answerA"
                @click="chooiceQuestion7($event, 'A')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">A. 东方红一号</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 A END-->

              <!--选项 B BEGIN-->
              <div
                class="answer answerB"
                @click="chooiceQuestion7($event, 'B')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">B. 嫦娥一号</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 B END-->

              <!--选项 C BEGIN-->
              <div
                class="answer answerC"
                @click="chooiceQuestion7($event, 'C')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">C. 天宫一号</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 C END-->

              <!--选项 D BEGIN-->
              <div
                class="answer answerD"
                @click="chooiceQuestion7($event, 'D')"
              >
                <div class="answerInner">
                  <div class="leftsidebar"></div>
                  <div class="inner">
                    <div class="innerTxt">D. 神舟一号</div>
                  </div>
                  <div class="rightsidebar"></div>
                </div>
              </div>
              <!--选项 D END-->
            </div>
          </div>
          <!--题目7 END-->
        </div>
      </div>

      <!--航天知识星图-->
      <div class="xingtu" :style="{ bottom: jiqiHeight }" v-show="xingtuState">
        <div class="xingtuLoading" v-show="!xintuWrapperState">
          <div class="xtloading xtloading1"></div>
        </div>
        <div class="xintuWrapper" v-show="xintuWrapperState">
          <div class="xtContent">
            <div class="xingtuInner">
              <div class="dian dian1" @click="dianPlay(1)"></div>
              <div class="dian dian2" @click="dianPlay(2)"></div>
              <div class="dian dian3" @click="dianPlay(3)"></div>
              <div class="dian dian4" @click="dianPlay(4)"></div>
              <div class="dian dian5" @click="dianPlay(5)"></div>
              <div class="dian dian6" @click="dianPlay(6)"></div>
              <div class="dian dian7" @click="dianPlay(7)"></div>
              <div class="wdot wdot1" @click="dianPlay(1)"></div>
              <div class="wdot wdot2" @click="dianPlay(2)"></div>
              <div class="wdot wdot3" @click="dianPlay(3)"></div>
              <div class="wdot wdot4" @click="dianPlay(4)"></div>
              <div class="wdot wdot5" @click="dianPlay(5)"></div>
              <div class="wdot wdot6" @click="dianPlay(6)"></div>
              <div class="wdot wdot7" @click="dianPlay(7)"></div>
            </div>
          </div>
          <div class="xtDotContent">
            <div class="xingtuInner">
              <!--点1 BEGIN-->
              <div class="dot dot1">
                <div class="dotInner" :class="{ dotdotWrong: dot1dot }"></div>
              </div>
              <!--点1 END-->

              <!--点2 BEGIN-->
              <div class="dot dot2">
                <div class="dotInner" :class="{ dotdotWrong: dot2dot }"></div>
              </div>
              <!--点2 END-->

              <!--点3 BEGIN-->
              <div class="dot dot3">
                <div class="dotInner" :class="{ dotdotWrong: dot3dot }"></div>
              </div>
              <!--点3 END-->

              <!--点4 BEGIN-->
              <div class="dot dot4">
                <div class="dotInner" :class="{ dotdotWrong: dot4dot }"></div>
              </div>
              <!--点4 END-->

              <!--点5 BEGIN-->
              <div class="dot dot5">
                <div class="dotInner" :class="{ dotdotWrong: dot5dot }"></div>
              </div>
              <!--点5 END-->

              <!--点6 BEGIN-->
              <div class="dot dot6">
                <div class="dotInner" :class="{ dotdotWrong: dot6dot }"></div>
              </div>
              <!--点6 END-->

              <!--点7 BEGIN-->
              <div class="dot dot7">
                <div class="dotInner" :class="{ dotdotWrong: dot7dot }"></div>
              </div>
              <!--点7 END-->
            </div>
          </div>
          <div
            class="xingtuSelected"
            :style="{ backgroundImage: 'url(' + dianSelectUrl + ')' }"
          ></div>
          <div class="xingtuBg"></div>
        </div>
      </div>
      <div
        class="makehaibaoBtn"
        v-show="makeHaibaoBtnState"
        @click="showMakeHaibao"
      ></div>
    </div>
    <!--问题大赏 END-->

    <!--照片生成海报 BEGIN-->
    <div class="listHaibaoWrapper" v-show="listHaibaoState">
      <div class="datiTitle">
        <div
          class="daNum"
          :class="{
            daNum0: datiTitleQ0,
            daNum1: datiTitleQ1,
            daNum2: datiTitleQ2,
            daNum3: datiTitleQ3,
            daNum4: datiTitleQ4,
            daNum5: datiTitleQ5,
            daNum6: datiTitleQ6,
            daNum7: datiTitleQ7,
          }"
        ></div>
      </div>

      <div
        class="daDescption"
        :class="{
          daDescption0: datiDescption0,
          daDescption1: datiDescption1,
          daDescption2: datiDescption2,
        }"
      ></div>
      <div class="haibaoWWrapper">
        <!--海报 BEGIN-->
        <div class="hbWrapper">
          <div class="lbox" @click="makeHaibao('small')">
            <div class="wbox" :class="{ selected: children1 }">
              <div class="wboxInner"><img src="./img/tdsmall1.jpg" /></div>
            </div>
            <div class="wbox" :class="{ selected: children2 }">
              <div class="wboxInner"><img src="./img/tdsmall2.jpg" /></div>
            </div>
            <div class="wbox" :class="{ selected: children3 }">
              <div class="wboxInner"><img src="./img/tdsmall3.jpg" /></div>
            </div>
          </div>
          <div class="hbwBtn hbw1" @click="makeHaibao('small')"></div>
        </div>
        <!--海报 END-->

        <!--海报 BEGIN-->
        <div class="hbWrapper">
          <div class="lbox" @click="makeHaibao('big')">
            <div class="wbox" :class="{ selected: people1 }">
              <div class="wboxInner"><img src="./img/tdbig1.jpg" /></div>
            </div>
            <div class="wbox" :class="{ selected: people2 }">
              <div class="wboxInner"><img src="./img/tdbig2.jpg" /></div>
            </div>
            <div class="wbox" :class="{ selected: people3 }">
              <div class="wboxInner"><img src="./img/tdbig3.jpg" /></div>
            </div>
          </div>
          <div class="hbwBtn hbw2" @click="makeHaibao('big')"></div>
        </div>
        <!--海报 END-->
      </div>
    </div>
    <!--照片生成海报 END-->

    <!--生成专属航天海报 BEGIN-->
    <div class="haibaomake" v-show="haibaomakeState">
      <div class="makemake">
        <!-- <div class="handmask" @click="letPhotoUpload"></div> -->
        <div class="makemakeInner">
          <div class="mmTop">
            <div class="mmBottom">
              <div id="haibaoContainer"></div>
              <div class="uploadBtn">
                <input
                  id="imageInput1"
                  class="inpfile"
                  type="file"
                  name="photo"
                  accept="image/*"
                  hidden="hidden"
                  @change="uploadPhoto($event)"
                />
              </div>
            </div>
          </div>
          <div class="line">
            <div class="lineBg"></div>
          </div>
        </div>
      </div>
      <div class="mhaibaoBtn" @click="letUsGo"></div>
    </div>
    <!--生成专属航天海报 END-->

    <!--落地页 BEGIN-->
    <div class="luodipage" v-show="myhaibaoState">
      <div class="myhaibaoLayer">
        <div class="ldHaibao">
          <div class="hdMyHaibao"><img :src="dataURL" /></div>
          <div class="saveTip"></div>
        </div>
        <div class="btnBox">
          <div class="obtn replayBtn" @click="replayAction"></div>
          <div class="obtn shareBtn" @click="shareAction"></div>
        </div>
      </div>
    </div>
    <div class="sharelayer" v-show="shareLayerState" @click="hideShareLayer">
      <div class="shareLayerInner">
        <div class="shareLayerTip" :class="{ fly: shareTipState }"></div>
      </div>
    </div>
    <!--落地页 END-->

    <div class="selfToast" v-show="isToastShow">
      {{ toastMsg }}
    </div>

    <!--流星-->
    <div class="liuxingBox">
      <div class="lx lx1"></div>
      <div class="lx lx3"></div>
      <div class="lx lx4"></div>
      <div class="lx lx6"></div>
    </div>

    <!--星空闪闪-->
    <div class="xingkongBox">
      <div class="xk xk4"></div>
      <div class="xk xk5"></div>
      <div class="xk xk7"></div>
      <div class="xk xk8"></div>
      <div class="xk xk9"></div>
    </div>

    <!--星球-->
    <div class="dtxingqiu"></div>
  </div>
</template>

<script>
import * as PIXI from "pixi.js";
import $ from "jquery";
import lrz from "lrz";
import { TweenMax } from "gsap";
import AlloyFinger from "alloyfinger";

export default {
  name: "PageOne",
  props: {
    isShow: Object,
  },
  data() {
    return {
      wendaState: true,
      questionkuangState: true,
      xingtuState: false,
      question1State: false,
      question2State: false,
      question3State: false,
      question4State: false,
      question5State: false,
      question6State: false,
      question7State: false,
      question1FlagState: true,
      question2FlagState: true,
      question3FlagState: true,
      question4FlagState: true,
      question5FlagState: true,
      question6FlagState: true,
      question7FlagState: true,
      rightAnswer: ["B", "A", "C", "C", "A", "A", "D"],
      answerRightCls: require("./img/q-green.png"),
      answerWrongCls: require("./img/q-red.png"),
      dotXingtuRight: [
        require("./img/dot1-r.png"),
        require("./img/dot2-r.png"),
        require("./img/dot3-r.png"),
        require("./img/dot4-r.png"),
        require("./img/dot5-r.png"),
        require("./img/dot6-r.png"),
        require("./img/dot7-r.png"),
      ],
      dotXingtuWrong: [
        require("./img/dot1-w.png"),
        require("./img/dot2-w.png"),
        require("./img/dot3-w.png"),
        require("./img/dot4-w.png"),
        require("./img/dot5-w.png"),
        require("./img/dot6-w.png"),
        require("./img/dot7-w.png"),
      ],
      questionArr: [1, 1, 1, 1, 1, 1, 1],
      timeDur: 500,
      dotww1: "",
      dotww2: "",
      dotww3: "",
      dotww4: "",
      dotww5: "",
      dotww6: "",
      dotww7: "",
      dianSelectUrl: "",
      dianSelectUrl2: require("./img/jiqi-txt.png"),
      dot1dot: false,
      dot2dot: false,
      dot3dot: false,
      dot4dot: false,
      dot5dot: false,
      dot6dot: false,
      dot7dot: false,
      makeHaibaoBtnState: false,
      xintuWrapperState: false,
      haibaoNum: 7,
      children1: false,
      children2: false,
      children3: false,
      people1: false,
      people2: false,
      people3: false,
      listHaibaoState: false,
      haibaomakeState: true,
      dataURL: "",
      app: null,
      dragging: false,
      data: { x: 0, y: 0, scaleX: 1, scaleY: 1, rotation: 0 },
      position: { x: 0, y: 0 },
      scaleZoom: { x: 0, y: 0 },
      rotationDegree: { degree: 0 },
      isToastShow: false,
      toastMsg: "",
      isphoto: false,
      canDianState: true,
      dtbgState: false,
      dtbgZhuanState: false,
      q1State: false,
      q2State: false,
      q3State: false,
      q4State: false,
      q5State: false,
      q6State: false,
      q7State: false,
      modulemodule: "small1",
      myhaibaoState: false,
      shareLayerState: false,
      shareTipState: false,
      jiqiHeight: 0,
      jiqiDurBottom: 0,
      jiqiDurBottom2: "bottom",
      datiTitleQ0: false,
      datiTitleQ1: false,
      datiTitleQ2: false,
      datiTitleQ3: false,
      datiTitleQ4: false,
      datiTitleQ5: false,
      datiTitleQ6: false,
      datiTitleQ7: false,
      datiDescption0: false,
      datiDescption1: false,
      datiDescption2: false,
      isLock: false,
    };
  },
  mounted() {
    this.pageOnePrepair();
  },
  methods: {
    // showNext() {
    //   setTimeout(() => {
    //     this.$emit("nextPage", "isPTShow");
    //   }, 200);
    // },
    replayAction() {
      //location.href = location.href + "?random=" + Math.random();
      let data = {
        para: "isKVShow",
      };
      this.$emit("nextPage", data);
    },
    shareAction() {
      this.shareLayerState = true;
      this.shareTipState = false;

      TweenMax.fromTo(".shareLayerTip", 2, { top: "400px" }, { top: "25px" });
      setTimeout(() => {
        this.shareTipState = true;
      }, 2000);
    },
    hideShareLayer() {
      this.shareLayerState = false;
    },
    letPhotoUpload() {
      if (this.canDianState && !this.isLock) {
        $("#imageInput1").trigger("click");
      }
    },
    dianPlay(seq) {
      this.dianSelectUrl = require("./img/xingtu-q" + seq + ".png");
      this.dianSelectUrl2 = require("./img/jiqi-txt" + seq + ".png");
    },
    showMakeHaibao() {
      this.wendaState = false;
      this.listHaibaoState = true;

      // 答对0-3，对应1号海报背景
      // 答对4-6，对应2号海报背景
      // 答对7题，对应3号海报背景
      if (this.haibaoNum <= 3) {
        this.children1 = true;
        this.people1 = true;
        this.datiDescption0 = true;
      }

      if (this.haibaoNum > 3 && this.haibaoNum < 7) {
        this.children2 = true;
        this.people2 = true;
        this.datiDescption1 = true;
      }

      if (this.haibaoNum >= 7) {
        this.children3 = true;
        this.people3 = true;
        this.datiDescption2 = true;
      }

      if (this.haibaoNum == 0) {
        this.datiTitleQ0 = true;
      } else if (this.haibaoNum == 1) {
        this.datiTitleQ1 = true;
      } else if (this.haibaoNum == 2) {
        this.datiTitleQ2 = true;
      } else if (this.haibaoNum == 3) {
        this.datiTitleQ3 = true;
      } else if (this.haibaoNum == 4) {
        this.datiTitleQ4 = true;
      } else if (this.haibaoNum == 5) {
        this.datiTitleQ5 = true;
      } else if (this.haibaoNum == 6) {
        this.datiTitleQ6 = true;
      } else if (this.haibaoNum == 7) {
        this.datiTitleQ7 = true;
      }
    },
    makeHaibao(w) {
      let modulepic = require("./img/mhaibao1.png");
      let ewmpic = require("./img/mEwm1.png");

      // 答对0-3，对应1号海报背景
      // 答对4-6，对应2号海报背景
      // 答对7题，对应3号海报背景

      if (w == "small") {
        if (this.haibaoNum <= 3) {
          this.modulemodule = "small1";
          modulepic = require("./img/mhaibao1.png");
          ewmpic = require("./img/mEwm1.png");
        }

        if (this.haibaoNum > 3 && this.haibaoNum < 7) {
          this.modulemodule = "small2";
          modulepic = require("./img/mhaibao2.png");
          ewmpic = require("./img/mEwm2.png");
        }

        if (this.haibaoNum >= 7) {
          this.modulemodule = "small3";
          modulepic = require("./img/mhaibao3.png");
          ewmpic = require("./img/mEwm3.png");
        }
      }

      if (w == "big") {
        if (this.haibaoNum <= 3) {
          this.modulemodule = "big1";
          modulepic = require("./img/bighaibao1.png");
          ewmpic = require("./img/bigEwm1.png");
        }

        if (this.haibaoNum > 3 && this.haibaoNum < 7) {
          this.modulemodule = "big2";
          modulepic = require("./img/bighaibao2.png");
          ewmpic = require("./img/bigEwm2.png");
        }

        if (this.haibaoNum >= 7) {
          this.modulemodule = "big3";
          modulepic = require("./img/bighaibao3.png");
          ewmpic = require("./img/bigEwm3.png");
        }
      }

      let mm = 40;

      //模板模板
      let modela1 = {
        top: 359 + mm,
        left: 399 + mm,
        width: 351 - 2 * mm,
        height: 339 - 2 * mm,
        rotation: (Math.PI / 180) * 20,
      };

      //小孩
      if (this.modulemodule == "small1") {
        modela1 = {
          top: 524 + mm,
          left: 30 + mm,
          width: 354 - 2 * mm,
          height: 282 - 2 * mm,
          rotation: 0,
        };
      } else if (this.modulemodule == "small2") {
        modela1 = {
          top: 409 + mm,
          left: 232 + mm,
          width: 301 - 2 * mm,
          height: 245 - 2 * mm,
          rotation: 0,
        };
      } else if (this.modulemodule == "small3") {
        modela1 = {
          top: 401 + mm,
          left: 362 + mm,
          width: 349 - 2 * mm,
          height: 336 - 2 * mm,
          rotation: (Math.PI / 180) * 20,
        };
      }

      //大人
      if (this.modulemodule == "big1") {
        modela1 = {
          top: 429 + mm,
          left: 41 + mm,
          width: 356 - 2 * mm,
          height: 353 - 2 * mm,
          rotation: 0,
        };
      } else if (this.modulemodule == "big2") {
        modela1 = {
          top: 357 + mm,
          left: 226 + mm,
          width: 299 - 2 * mm,
          height: 280 - 2 * mm,
          rotation: 0,
        };
      } else if (this.modulemodule == "big3") {
        modela1 = {
          top: 467 + mm,
          left: 358 + mm,
          width: 369 - 2 * mm,
          height: 333 - 2 * mm,
          rotation: (Math.PI / 180) * 10,
        };
      }

      this.app.stage.getChildByName("bunny2").x =
        modela1.left + modela1.width / 2;
      this.app.stage.getChildByName("bunny2").y =
        modela1.top + modela1.height / 2;
      this.app.stage.getChildByName("bunny2").rotation = modela1.rotation;

      //小孩第三张修复位置
      if (this.modulemodule == "small3") {
        this.app.stage.getChildByName("bunny2").x =
          this.app.stage.getChildByName("bunny2").x + 30;
        this.app.stage.getChildByName("bunny2").y =
          this.app.stage.getChildByName("bunny2").y - 30;
      }

      //更改模板图
      let randIndex = "mmm" + Math.random(1, 10000);
      let ewmRandIndex = "ewm" + Math.random(1, 10000);
      this.app.loader
        .add(randIndex, modulepic)
        .add(ewmRandIndex, ewmpic)
        .load((loader, resources) => {
          this.app.stage.getChildByName("bunny").texture =
            resources[randIndex].texture;

          this.app.stage.getChildByName("bunnyewm").texture =
            resources[ewmRandIndex].texture;
        });

      this.listHaibaoState = false;
      this.haibaomakeState = true;
    },
    chooiceQuestion1(e, o) {
      this.repaireTopBottom();
      this.makehaHaibao();
      let event = e.currentTarget;

      if (this.question1FlagState) {
        this.question1FlagState = false;

        //判断正确与错误
        if (o == this.rightAnswer[0]) {
          //正确
          event.style.backgroundImage = "url(" + this.answerRightCls + ")";
          this.dotww1 = this.dotXingtuRight[0];
        } else {
          //错误
          event.style.backgroundImage = "url(" + this.answerWrongCls + ")";
          this.dotww1 = this.dotXingtuWrong[0];
          this.questionArr[0] = 0;
          this.dot1dot = true;
          this.haibaoNum--;
        }

        setTimeout(() => {
          this.question1State = false;
          this.question2State = true;
          this.question3State = false;
          this.question4State = false;
          this.question5State = false;
          this.question6State = false;
          this.question7State = false;

          this.q2State = true;
          setTimeout(() => {
            TweenMax.fromTo(
              ".question2 .answerA",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question2 .answerB",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
          }, 500);
        }, this.timeDur);
      }
    },
    chooiceQuestion2(e, o) {
      this.photoJiaohu();
      let event = e.currentTarget;

      if (this.question2FlagState) {
        this.question2FlagState = false;

        //判断正确与错误
        if (o == this.rightAnswer[1]) {
          //正确
          event.style.backgroundImage = "url(" + this.answerRightCls + ")";
          this.dotww2 = this.dotXingtuRight[1];
        } else {
          //错误
          event.style.backgroundImage = "url(" + this.answerWrongCls + ")";
          this.dotww2 = this.dotXingtuWrong[1];
          this.questionArr[1] = 0;
          this.dot2dot = true;
          this.haibaoNum--;
        }

        setTimeout(() => {
          this.q3State = true;
          setTimeout(() => {
            TweenMax.fromTo(
              ".question3 .answerA",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question3 .answerB",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question3 .answerC",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question3 .answerD",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
          }, 500);

          this.question1State = false;
          this.question2State = false;
          this.question3State = true;
          this.question4State = false;
          this.question5State = false;
          this.question6State = false;
          this.question7State = false;
        }, this.timeDur);
      }
    },
    chooiceQuestion3(e, o) {
      let event = e.currentTarget;

      if (this.question3FlagState) {
        this.question3FlagState = false;

        //判断正确与错误
        if (o == this.rightAnswer[2]) {
          //正确
          event.style.backgroundImage = "url(" + this.answerRightCls + ")";
          this.dotww3 = this.dotXingtuRight[2];
        } else {
          //错误
          event.style.backgroundImage = "url(" + this.answerWrongCls + ")";
          this.dotww3 = this.dotXingtuWrong[2];
          this.questionArr[2] = 0;
          this.dot3dot = true;
          this.haibaoNum--;
        }

        setTimeout(() => {
          this.q4State = true;
          setTimeout(() => {
            TweenMax.fromTo(
              ".question4 .answerA",
              0.5,
              { width: "0.875rem" },
              { width: "8.2rem" }
            );
            TweenMax.fromTo(
              ".question4 .answerB",
              0.5,
              { width: "0.875rem" },
              { width: "8.2rem" }
            );
            TweenMax.fromTo(
              ".question4 .answerC",
              0.5,
              { width: "0.875rem" },
              { width: "8.2rem" }
            );
            TweenMax.fromTo(
              ".question4 .answerD",
              0.5,
              { width: "0.875rem" },
              { width: "8.2rem" }
            );
          }, 500);

          this.question1State = false;
          this.question2State = false;
          this.question3State = false;
          this.question4State = true;
          this.question5State = false;
          this.question6State = false;
          this.question7State = false;
        }, this.timeDur);
      }
    },
    chooiceQuestion4(e, o) {
      let event = e.currentTarget;

      if (this.question4FlagState) {
        this.question4FlagState = false;

        //判断正确与错误
        if (o == this.rightAnswer[3]) {
          //正确
          event.style.backgroundImage = "url(" + this.answerRightCls + ")";
          this.dotww4 = this.dotXingtuRight[3];
        } else {
          //错误
          event.style.backgroundImage = "url(" + this.answerWrongCls + ")";
          this.dotww4 = this.dotXingtuWrong[3];
          this.questionArr[3] = 0;
          this.dot4dot = true;
          this.haibaoNum--;
        }

        setTimeout(() => {
          this.q5State = true;
          setTimeout(() => {
            TweenMax.fromTo(
              ".question5 .answerA",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question5 .answerB",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question5 .answerC",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question5 .answerD",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
          }, 500);

          this.question1State = false;
          this.question2State = false;
          this.question3State = false;
          this.question4State = false;
          this.question5State = true;
          this.question6State = false;
          this.question7State = false;
        }, this.timeDur);
      }
    },
    chooiceQuestion5(e, o) {
      let event = e.currentTarget;

      if (this.question5FlagState) {
        this.question5FlagState = false;

        //判断正确与错误
        if (o == this.rightAnswer[4]) {
          //正确
          event.style.backgroundImage = "url(" + this.answerRightCls + ")";
          this.dotww5 = this.dotXingtuRight[4];
        } else {
          //错误
          event.style.backgroundImage = "url(" + this.answerWrongCls + ")";
          this.dotww5 = this.dotXingtuWrong[4];
          this.questionArr[4] = 0;
          this.dot5dot = true;
          this.haibaoNum--;
        }

        setTimeout(() => {
          this.q6State = true;
          setTimeout(() => {
            TweenMax.fromTo(
              ".question6 .answerA",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question6 .answerB",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question6 .answerC",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question6 .answerD",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
          }, 500);
          this.question1State = false;
          this.question2State = false;
          this.question3State = false;
          this.question4State = false;
          this.question5State = false;
          this.question6State = true;
          this.question7State = false;
        }, this.timeDur);
      }
    },
    chooiceQuestion6(e, o) {
      let event = e.currentTarget;

      if (this.question6FlagState) {
        this.question6FlagState = false;

        //判断正确与错误
        if (o == this.rightAnswer[5]) {
          //正确
          event.style.backgroundImage = "url(" + this.answerRightCls + ")";
          this.dotww6 = this.dotXingtuRight[5];
        } else {
          //错误
          event.style.backgroundImage = "url(" + this.answerWrongCls + ")";
          this.dotww6 = this.dotXingtuWrong[5];
          this.questionArr[5] = 0;
          this.dot6dot = true;
          this.haibaoNum--;
        }

        setTimeout(() => {
          this.q7State = true;
          setTimeout(() => {
            TweenMax.fromTo(
              ".question7 .answerA",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question7 .answerB",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question7 .answerC",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
            TweenMax.fromTo(
              ".question7 .answerD",
              0.5,
              { width: "0.875rem" },
              { width: "6.8125rem" }
            );
          }, 500);

          this.question1State = false;
          this.question2State = false;
          this.question3State = false;
          this.question4State = false;
          this.question5State = false;
          this.question6State = false;
          this.question7State = true;
        }, this.timeDur);
      }
    },
    chooiceQuestion7(e, o) {
      let event = e.currentTarget;

      if (this.question7FlagState) {
        this.question7FlagState = false;

        //判断正确与错误
        if (o == this.rightAnswer[6]) {
          //正确
          event.style.backgroundImage = "url(" + this.answerRightCls + ")";
          this.dotww7 = this.dotXingtuRight[6];
        } else {
          //错误
          event.style.backgroundImage = "url(" + this.answerWrongCls + ")";
          this.dotww7 = this.dotXingtuWrong[6];
          this.questionArr[6] = 0;
          this.dot7dot = true;
          this.haibaoNum--;
        }

        setTimeout(() => {
          this.question1State = false;
          this.question2State = false;
          this.question3State = false;
          this.question4State = false;
          this.question5State = false;
          this.question6State = false;
          this.question7State = false;

          this.questionkuangState = false;
          this.xingtuState = true;

          setTimeout(() => {
            this.makeHaibaoBtnState = true;
            this.xintuWrapperState = true;
          }, 2000);
        }, this.timeDur);
      }
    },
    showToast(msg) {
      this.toastMsg = msg;
      this.isToastShow = true;
      // setTimeout(() => {
      //   this.isToastShow = false
      // }, 1500)
    },
    showToast2(msg) {
      this.toastMsg = msg;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 1500);
    },
    makehaHaibao() {
      this.app = new PIXI.Application({
        width: 750,
        height: 1334,
        backgroundColor: 0x000000,
        forceCanvas: true, //强制使用canvas引擎绘制
      });
      document.getElementById("haibaoContainer").appendChild(this.app.view);

      this.app.view.id = "appwrapper";
      this.app.view.style.width = "294px";

      //this.addImg("bunny", require("./img/mhaibao1.png"), 0), false);
      //this.addImg("bunny2", require("./img/photo.png"), 2, true);
      this.addImgLoad();
    },
    addImgLoad() {
      this.app.loader
        .add("bunny", require("./img/mhaibao1.png"))
        .add("bunny2", require("./img/add.png"))
        .add("bunnyewm", require("./img/mEwm1.png"))
        .load((loader, resources) => {
          let wsprite2 = new PIXI.Sprite(resources.bunny2.texture);
          wsprite2.x = 0; //app.renderer.width / 2;
          wsprite2.y = 0; //app.renderer.height / 2;
          wsprite2.name = "bunny2";
          wsprite2.interactive = true;

          wsprite2.anchor.set(0.5, 0.5);
          this.app.stage.addChild(wsprite2);

          let wsprite = new PIXI.Sprite(resources.bunny.texture);
          wsprite.x = 0; //app.renderer.width / 2;
          wsprite.y = 0; //app.renderer.height / 2;
          wsprite.name = "bunny";
          //wsprite.interactive = false;
          this.app.stage.addChild(wsprite);

          //二维码
          let wspriteewm = new PIXI.Sprite(resources.bunnyewm.texture);
          wspriteewm.x = 0; //app.renderer.width / 2;
          wspriteewm.y = 0; //app.renderer.height / 2;
          wspriteewm.name = "bunnyewm";
          wspriteewm.visible = false;
          //wsprite.interactive = false;
          this.app.stage.addChild(wspriteewm);

          //添加遮罩层
          var e = new PIXI.Graphics();
          e.beginFill(10932373), e.drawRect(0, 0, 750, 1334), e.endFill();
          this.app.stage.mask = e;
        });
    },
    addImg(picName, picUrl, zIndex, interactive) {
      this.app.loader.add(picName, picUrl).load((loader, resources) => {
        // This creates a texture from a 'bunny.png' image
        let wsprite = new PIXI.Sprite(resources[picName].texture);

        // Setup the position of the bunny
        wsprite.x = 0; //app.renderer.width / 2;
        wsprite.y = 0; //app.renderer.height / 2;
        wsprite.name = picName;
        wsprite.interactive = interactive;

        // Rotate around the center
        //bunny.anchor.x = 0.5;
        //bunny.anchor.y = 0.5;

        //bunny.width = this.app.renderer.width;
        //bunny.height = this.app.renderer.height;

        // Add the bunny to the scene we are building
        //this.app.stage.addChild(wsprite);
        this.app.stage.addChildAt(wsprite, zIndex);

        // Listen for frame updates
        //app.ticker.add(() => {
        // each frame we spin the bunny around a bit
        //bunny.rotation += 0.01;
        //});
      });
    },
    letUsGo() {
      this.isToastShow = false;
      if (this.isphoto) {
        //this.dataURL = this.app.renderer.plugins.extract.base64(this.app.stage);
        this.app.stage.getChildByName("bunnyewm").visible = true;

        this.app.render();
        this.dataURL = this.app.view.toDataURL();

        // setTimeout(() => {
        //   let data = {
        //     para: "isPTShow",
        //     picpic: this.dataURL,
        //   };
        //   this.$emit("nextPage", data);
        // }, 200);

        this.haibaomakeState = false;
        this.myhaibaoState = true;
      } else {
        this.showToast2("请上传正面脸照片");
      }
    },
    uploadPhoto(event) {
      let _this = this;
      _this.showToast("照片添加中...");
      var img = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(img);
      if (img) {
        reader.onprogress = function () {
          _this.showToast("照片读取中...");
        };
        reader.onload = function (e) {
          _this.showToast("照片读取完成...");
          _this.isphoto = true;
          _this.canDianState = false;
          var pic = e.target.result;
          //_this.dataURL= pic;

          let randIndex = "www" + Math.random(1, 10000);
          _this.app.loader.add(randIndex, pic).load((loader, resources) => {
            _this.app.stage.getChildByName("bunny2").texture =
              resources[randIndex].texture;
            _this.app.stage.getChildByName("bunny2").x = 0;
            _this.app.stage.getChildByName("bunny2").y = 0;
          });

          //上传照片

          lrz(img, { quality: 0.4 })
            .then(function (rst) {
              // 处理成功会执行
              _this.doUpload(rst);
            })
            .catch(function (err) {
              console.log("err:" + err);
              // 处理失败会执行
              _this.isToastShow = false;
              _this.canDianState = true;
            })
            .always(function () {
              // 不管是成功失败，都会执行
            });
        };
        reader.onerror = function () {
          _this.canDianState = true;
        };
      } else {
        this.isToastShow = false;
        this.canDianState = true;
      }
    },
    doUpload(imgbase64) {
      let _this = this;
      var formData = new FormData();
      let base64tobinary = imgbase64.base64.split(";base64,")[1];
      formData.append("imagefile", base64tobinary);
      $.ajax({
        url: "https://www.jiandoukeji.com/codes/2018/renlianronghe/game.php/Home/Index/JDOU_detect/",
        type: "POST",
        data: formData,
        contentType: false, // 不设置Content-Type请求头
        processData: false, // 不处理发送的数据
        success: function (returndata) {
          _this.pinjietu(returndata);
        },
        error: function () {},
      });
    },
    pinjietu(data) {
      this.showToast("合成中...");
      if (data["faces"].length > 0) {
        this.showToast("制作中...");
        //this.isphoto = true;

        let faceInfo = data["faces"][0]["face_rectangle"];

        let mm = 40;

        //模板模板
        let modela1 = {
          top: 359 + mm,
          left: 399 + mm,
          width: 351 - 2 * mm,
          height: 339 - 2 * mm,
          rotation: (Math.PI / 180) * 20,
        };

        //小孩
        if (this.modulemodule == "small1") {
          modela1 = {
            top: 524 + mm,
            left: 30 + mm,
            width: 354 - 2 * mm,
            height: 282 - 2 * mm,
            rotation: 0,
          };
        } else if (this.modulemodule == "small2") {
          modela1 = {
            top: 409 + mm,
            left: 232 + mm,
            width: 301 - 2 * mm,
            height: 245 - 2 * mm,
            rotation: 0,
          };
        } else if (this.modulemodule == "small3") {
          modela1 = {
            top: 401 + mm,
            left: 362 + mm,
            width: 349 - 2 * mm,
            height: 336 - 2 * mm,
            rotation: (Math.PI / 180) * 20,
          };
        }

        //大人
        if (this.modulemodule == "big1") {
          modela1 = {
            top: 429 + mm,
            left: 41 + mm,
            width: 356 - 2 * mm,
            height: 353 - 2 * mm,
            rotation: 0,
          };
        } else if (this.modulemodule == "big2") {
          modela1 = {
            top: 357 + mm,
            left: 226 + mm,
            width: 299 - 2 * mm,
            height: 280 - 2 * mm,
            rotation: 0,
          };
        } else if (this.modulemodule == "big3") {
          modela1 = {
            top: 467 + mm,
            left: 358 + mm,
            width: 369 - 2 * mm,
            height: 333 - 2 * mm,
            rotation: (Math.PI / 180) * 10,
          };
        }

        let scaleA1 = modela1.width / faceInfo.width;

        this.app.stage.getChildByName("bunny2").x =
          modela1.left + modela1.width / 2;
        this.app.stage.getChildByName("bunny2").y =
          modela1.top + modela1.height / 2;

        this.app.stage.getChildByName("bunny2").scale.x = scaleA1;
        this.app.stage.getChildByName("bunny2").scale.y = scaleA1;
        this.app.stage.getChildByName("bunny2").rotation = modela1.rotation;

        this.data.x = this.app.stage.getChildByName("bunny2").x;
        this.data.y = this.app.stage.getChildByName("bunny2").y;
        this.data.scaleX = this.app.stage.getChildByName("bunny2").scale.x;
        this.data.scaleY = this.app.stage.getChildByName("bunny2").scale.y;
        this.data.rotation = this.app.stage.getChildByName("bunny2").rotation;

        this.isToastShow = false;
        this.canDianState = true;
      } else {
        //this.isphoto = false;
        this.showToast2("无法识别到人脸");
        this.canDianState = true;
      }
    },
    photoJiaohu() {
      let _this = this;
      // this.app.stage
      //   .getChildByName("bunny2")
      //   .on("touchstart", this.onDragStart)
      //   .on("touchmove", this.onDragMove)
      //   .on("touchend", this.onDragEnd);

      new AlloyFinger("#haibaoContainer", {
        touchStart: function (evt) {
          _this.onDragStart(evt.touches[0]);
        },
        touchMove: function (evt) {
          _this.onDragMove(evt.touches[0]);
        },
        touchEnd: function () {
          _this.onDragEnd();
        },
        touchCancel: function () {
          _this.isToastShow = false;
          _this.canDianState = true;
        },
        rotate: function (evt) {
          console.log(evt.angle);
          // document.getElementById("info").innerHTML =
          //   _this.data.rotation + "!!!" + evt.angle;
          // _this.app.stage.getChildByName("bunny2").rotation =
          //   _this.data.rotation + evt.angle* Math.PI;
        },
        tap: function () {
          _this.letPhotoUpload();
        },
        pinch: function (evt) {
          let scaleXX = _this.data.scaleX + evt.zoom - 1;
          let scaleYY = _this.data.scaleY + evt.zoom - 1;
          if (scaleXX > 0) {
            _this.app.stage.getChildByName("bunny2").scale.x = scaleXX;
          }
          if (scaleYY > 0) {
            _this.app.stage.getChildByName("bunny2").scale.y = scaleYY;
          }
        },
      });
    },
    //开始拖拽
    onDragStart(obj) {
      console.log("开始拖拽");
      setTimeout(() => {
        this.isLock = true;
      }, 800);

      this.position = { x: obj.pageX, y: obj.pageY };
      this.dragging = true;
    },
    //拖拽移动中
    onDragMove(obj) {
      console.log("拖拽移动中");
      if (this.dragging) {
        this.app.stage.getChildByName("bunny2").x =
          this.data.x + obj.pageX - this.position.x;
        this.app.stage.getChildByName("bunny2").y =
          this.data.y + obj.pageY - this.position.y;
      }
    },
    //拖拽完成，松开鼠标或抬起手指
    onDragEnd() {
      setTimeout(() => {
        this.isLock = false;
      }, 800);

      console.log("拖拽完成，松开鼠标或抬起手指");
      this.dragging = false;
      this.data = {
        x: this.app.stage.getChildByName("bunny2").x,
        y: this.app.stage.getChildByName("bunny2").y,
        scaleX: this.app.stage.getChildByName("bunny2").scale.x,
        scaleY: this.app.stage.getChildByName("bunny2").scale.y,
        rotation: this.app.stage.getChildByName("bunny2").rotation,
      };
    },
    pageOnePrepair() {
      //屏幕尺寸
      let _w = $(window).width();
      let _h = $(window).height();

      //机器框
      let h = (617 / 744) * _w;

      //答题页机器
      let jiqih = (704 / 750) * _w;

      let bottomHH = jiqih;

      let durdur = _h - jiqih - h;
      if (durdur < 0) {
        bottomHH = jiqih + durdur;
        this.jiqiDurBottom2 = durdur + "px";
        this.jiqiDurBottom = durdur + "px";
      } else if (durdur < 2.5 && durdur >= 0) {
        bottomHH = jiqih - (80 - durdur);
        this.jiqiDurBottom2 = 0;
        this.jiqiDurBottom = -bottomHH / 2 + "px";
      } else if (durdur < 7 && durdur >= 2.5) {
        bottomHH = jiqih + durdur;
      }

      this.jiqiHeight = bottomHH + "px";
    },
    repaireTopBottom(){
      let _h = $(window).height();
      if(($(".makemake").height()+$(".mhaibaoBtn").height())>_h){
        $(".mhaibaoBtn").css({"position":"absolute","bottom":"5vh","z-index":"10"});
        $(".btnBox").css({"padding-top":"0","margin-top":"-10px"});
      }else{
        $(".mhaibaoBtn").css({"position":"relative","bottom":"0"});
        $(".btnBox").css({"padding-top":"10px","margin-top":"0"});
      }
    },
    pageOneReset() {
      this.wendaState = true;
      this.questionkuangState = true;
      this.xingtuState = false;
      this.question1State = false;
      this.question2State = false;
      this.question3State = false;
      this.question4State = false;
      this.question5State = false;
      this.question6State = false;
      this.question7State = false;
      this.question1FlagState = true;
      this.question2FlagState = true;
      this.question3FlagState = true;
      this.question4FlagState = true;
      this.question5FlagState = true;
      this.question6FlagState = true;
      this.question7FlagState = true;
      this.rightAnswer = ["B", "A", "C", "C", "A", "A", "D"];
      this.answerRightCls = require("./img/q-green.png");
      this.answerWrongCls = require("./img/q-red.png");
      this.dotXingtuRight = [
        require("./img/dot1-r.png"),
        require("./img/dot2-r.png"),
        require("./img/dot3-r.png"),
        require("./img/dot4-r.png"),
        require("./img/dot5-r.png"),
        require("./img/dot6-r.png"),
        require("./img/dot7-r.png"),
      ];
      this.dotXingtuWrong = [
        require("./img/dot1-w.png"),
        require("./img/dot2-w.png"),
        require("./img/dot3-w.png"),
        require("./img/dot4-w.png"),
        require("./img/dot5-w.png"),
        require("./img/dot6-w.png"),
        require("./img/dot7-w.png"),
      ];
      this.questionArr = [1, 1, 1, 1, 1, 1, 1];
      this.timeDur = 500;
      this.dotww1 = "";
      this.dotww2 = "";
      this.dotww3 = "";
      this.dotww4 = "";
      this.dotww5 = "";
      this.dotww6 = "";
      this.dotww7 = "";
      this.dianSelectUrl = "";
      this.dianSelectUrl2 = require("./img/jiqi-txt.png");
      this.dot1dot = false;
      this.dot2dot = false;
      this.dot3dot = false;
      this.dot4dot = false;
      this.dot5dot = false;
      this.dot6dot = false;
      this.dot7dot = false;
      this.makeHaibaoBtnState = false;
      this.xintuWrapperState = false;
      this.haibaoNum = 7;
      this.children1 = false;
      this.children2 = false;
      this.children3 = false;
      this.people1 = false;
      this.people2 = false;
      this.people3 = false;
      this.listHaibaoState = false;
      this.haibaomakeState = false;
      this.dataURL = "";
      this.app = null;
      this.dragging = false;
      this.data = { x: 0, y: 0, scaleX: 1, scaleY: 1, rotation: 0 };
      this.position = { x: 0, y: 0 };
      this.scaleZoom = { x: 0, y: 0 };
      this.rotationDegree = { degree: 0 };
      this.isToastShow = false;
      this.toastMsg = "";
      this.isphoto = false;
      this.canDianState = true;
      this.dtbgState = false;
      this.dtbgZhuanState = false;
      this.q1State = false;
      this.q2State = false;
      this.q3State = false;
      this.q4State = false;
      this.q5State = false;
      this.q6State = false;
      this.q7State = false;
      this.modulemodule = "small1";
      this.myhaibaoState = false;
      this.shareLayerState = false;
      this.shareTipState = false;
      this.jiqiHeight = 0;
      this.jiqiDurBottom = 0;
      this.jiqiDurBottom2 = "bottom";
      this.datiTitleQ0 = false;
      this.datiTitleQ1 = false;
      this.datiTitleQ2 = false;
      this.datiTitleQ3 = false;
      this.datiTitleQ4 = false;
      this.datiTitleQ5 = false;
      this.datiTitleQ6 = false;
      this.datiTitleQ7 = false;
      this.datiDescption0 = false;
      this.datiDescption1 = false;
      this.datiDescption2 = false;
      this.isLock = false;

      this.pageOnePrepair();
    },
  },
  watch: {
    "isShow.isPOShow": function () {
      //重置
      this.pageOneReset();

      this.dtbgState = true;
      setTimeout(() => {
        this.dtbgZhuanState = true;
      }, 1000);
      setTimeout(() => {
        this.question1State = true;

        this.q1State = true;
        setTimeout(() => {
          TweenMax.fromTo(
            ".question1 .answerA",
            0.5,
            { width: "0.875rem" },
            { width: "6.8125rem" }
          );
          TweenMax.fromTo(
            ".question1 .answerB",
            0.5,
            { width: "0.875rem" },
            { width: "6.8125rem" }
          );
          TweenMax.fromTo(
            ".question1 .answerC",
            0.5,
            { width: "0.875rem" },
            { width: "6.8125rem" }
          );
          TweenMax.fromTo(
            ".question1 .answerD",
            0.5,
            { width: "0.875rem" },
            { width: "6.8125rem" }
          );
        }, 500);
      }, 2000);
    },
  },
};
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.po {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-image: url("./img/pbg.jpg");
  background-size: auto 100%;
  background-repeat: repeat-x;
  animation: bgzhuan 120s infinite linear forwards;
}

@keyframes bgzhuan {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: right 0;
  }
  100% {
    background-position: 0 0;
  }
}

.poInner {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-image: url("./img/jiqi.png");
  background-position: center bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
  z-index: 3;
}

.dttaikongren {
  width: (46.875rem/2) /* 750/16 */;
  height: (44.25rem/2) /* 708/16 */;
  .bg("./img/yhyren.png");
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -(46.875rem/4) /* 750/16 */;
  z-index: 5;
}

.datikuang {
  width: (46.5rem/2) /* 744/16 */;
  height: (38.5625rem/2) /* 617/16 */;
  bottom: (43rem/2) /* 708/16 */;
  position: absolute;
  left: 50%;
  margin-left: -(46.5rem/4) /* 744/16 */;
}

.dtkInner {
  width: 100%;
  height: 100%;
  position: relative;
}

.dtkbg {
  width: (46.5rem/2) /* 744/16 */;
  height: (38.5625rem/2) /* 617/16 */;
  .bg("./img/datikuang.png");
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}

.quanxidong {
  animation: quanxidong 1.5s linear;
}

@keyframes quanxidong {
  0% {
    background-image: url(./img/photo.png);
  }
  1% {
    background-image: url(./img/photo.png);
  }
  33% {
    background-image: url(./img/datikuang-2-0.png);
  }
  60% {
    background-image: url(./img/datikuang-2-1.png);
  }
  80% {
    background-image: url(./img/datikuang-1.png);
  }
  100% {
    background-image: url(./img/datikuang.png);
  }
}

.dtkzhuanbg {
  width: (8.375rem/2) /* 134/16 */;
  height: (8.375rem/2) /* 134/16 */;
  .bg("./img/p2-1.png");
  position: absolute;
  left: 10px;
  top: 10px;
  transform-origin: 50% 50%;
  animation: zhanpan 10s infinite linear;
  z-index: 4;
}

@keyframes zhanpan {
  0% {
    transform: rotate(0deg);
  }
  0% {
    transform: rotate(360deg);
  }
}

.dtxingqiu {
  width: (27rem/2) /* 432/16 */;
  height: (26.9375rem/2) /* 431/16 */;
  .bg("./img/p2-2.png");
  position: absolute;
  left: -50px;
  top: 10vh;
  z-index: 1;
  transform-origin: 30vw 100vh;
  animation: xqzhuan 30s infinite linear;
}

@keyframes xqzhuan {
  0% {
    transform: rotate(-20deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

.xingtu {
  width: (40.5rem/2) /* 648/16 */;
  height: (34.125rem/2) /* 546/16 */;
  .bg("./img/datikuang2.png");
  position: absolute;
  bottom: (44rem/2) /* 708/16 */;
  position: absolute;
  left: 50%;
  margin-left: -(40.5rem/4) /* 648/16 */;
  z-index: 10;
}

.jiqiguang {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-image: url("./img/jiqi-guang.png");
  background-position: center bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
  z-index: 4;
}

.jiqi-0 {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-image: url("./img/jiqi-0.png");
  background-position: center bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
  z-index: 2;
  animation: jiqi0dong 2s steps(1, end) infinite;
}

@keyframes jiqi0dong {
  0% {
    background-image: url("./img/jiqi-0.png");
  }
  33.3% {
    background-image: url("./img/jiqi-0-0.png");
  }
  66.6% {
    background-image: url("./img/jiqi-0-1.png");
  }
  100% {
    background-image: url("./img/jiqi-0.png");
  }
}

.jiqiqq {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-position: center bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.jiqi-1 {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-image: url("./img/jiqi-1.png");
  background-position: center bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
  z-index: 4;
}

.jiqiwwInner {
  width: 100%;
  height: 100%;
  .bg("./img/jiqi-txt.png");
  background-position: center bottom;
  background-size: 100% auto;
}

.question {
  width: (46.5rem/2) /* 744/16 */;
  height: (38.5625rem/2) /* 617/16 */;
  position: absolute;
  z-index: 5;
  left: 0px;
  top: 0px;
  .questionInner {
    width: (46.5rem/2) /* 744/16 */;
    height: (38.5625rem/2) /* 617/16 */;
    position: relative;
  }
}

.answer {
  height: (4.625rem/2) /* 74/16 */;
  line-height: (4.625rem/2) /* 74/16 */;
  text-align: center;
  .bg("./img/q-blue1.png");
  background-size: 100% 100%;
  color: #fff;
  //width: (13.625rem/2) /* 218/16 */;
  width: 0.4375rem * 2;
  position: absolute;
  transform-origin: 50% 50%;
  overflow: hidden;

  .answerInner {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .innerTxt {
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    padding: 0 0.7rem;
  }
  .leftsidebar {
    width: (0.875rem/2) /* 14/16 */;
    height: (4.625rem/2) /* 74/16 */;
    .bg("./img/q-left.png");
    position: absolute;
    left: 0;
    top: 0;
  }
  .rightsidebar {
    width: (0.875rem/2) /* 14/16 */;
    height: (4.625rem/2) /* 74/16 */;
    .bg("./img/q-right.png");
    position: absolute;
    right: 0;
    top: 0;
  }
}

.answerA {
  left: (7.875rem/2) /* 126/16 */;
  top: (15.4375rem/2) /* 247/16 */;
}

.answerB {
  left: (24.625rem/2) /* 394/16 */;
  top: (15.4375rem/2) /* 247/16 */;
}

.answerC {
  left: (7.875rem/2) /* 126/16 */;
  top: (21.25rem/2) /* 340/16 */;
}

.answerD {
  left: (24.625rem/2) /* 126/16 */;
  top: (21.25rem/2) /* 340/16 */;
}

.question1 {
  .bg("./img/q1-bg.png");
  .questionInner {
    .bg("./img/q1.png");
  }
}

.question2 {
  .bg("./img/q2-bg.png");
  .questionInner {
    .bg("./img/q2.png");
  }

  .answerA {
    left: (16.375rem/2) /* 262/16 */;
  }

  .answerB {
    left: (16.375rem/2) /* 262/16 */;
    top: (21.25rem/2) /* 340/16 */;
  }

  .answerC,
  .answerD {
    display: none;
  }
}

.question3 {
  .bg("./img/q3-bg.png");
  .questionInner {
    .bg("./img/q3.png");
  }
}

.question4 {
  .bg("./img/q4-bg.png");
  .questionInner {
    .bg("./img/q4.png");
  }
  .answer {
    //width: (15.625rem/2) /* 250/16 */;
    width: 0.4375rem * 2;
  }

  .answerA {
    left: (6.2rem/2) /* 102/16 */;
  }

  .answerB {
    left: (24.1875rem/2) /* 387/16 */;
  }

  .answerC {
    left: (6.2rem/2) /* 102/16 */;
  }

  .answerD {
    left: (24.1875rem/2) /* 387/16 */;
  }
}

.question5 {
  .bg("./img/q5-bg.png");
  .questionInner {
    .bg("./img/q5.png");
  }
}

.question6 {
  .bg("./img/q6-bg.png");
  .questionInner {
    .bg("./img/q6.png");
  }
}

.question7 {
  .bg("./img/q7-bg.png");
  .questionInner {
    .bg("./img/q7.png");
  }
}

.answerRight {
  background-image: url("./img/q-green.png");
}

.answerWrong {
  background-image: url("./img/q-red.png");
}

.xintuWrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.xingtuLoading {
  width: 100%;
  height: 100%;
  position: relative;
  .bg("./img/xingtu-loading-bg.png");
}

.xtloading {
  position: absolute;
  width: 100%;
  height: 100%;
}

.xtloading1 {
  .bg("./img/xingtu-loading-0.png");
  animation: dianshan 3s infinite;
}

@keyframes dianshan {
  0% {
    .bg("./img/xingtu-loading-0.png");
  }
  24% {
    .bg("./img/xingtu-loading-0.png");
  }
  25% {
    .bg("./img/xingtu-loading-1.png");
  }
  49% {
    .bg("./img/xingtu-loading-1.png");
  }
  50% {
    .bg("./img/xingtu-loading-2.png");
  }
  74% {
    .bg("./img/xingtu-loading-2.png");
  }
  75% {
    .bg("./img/xingtu-loading-3.png");
  }
  100% {
    .bg("./img/xingtu-loading-3.png");
  }
}

.xingtuBg {
  width: 100%;
  height: 100%;
  .bg("./img/xingtu-bg.png");
  background-size: 100% auto;
  position: absolute;
  left: 0;
  top: 0;
}

.xingtuSelected {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.dian {
  width: (7.5rem/2) /* 120/16 */;
  height: (2.8125rem/2) /* 45/16 */;
  position: absolute;
}

.dian1 {
  left: (3.25rem/2) /* 52/16 */;
  top: (10.25rem/2) /* 164/16 */;
}

.dian2 {
  left: (18.0625rem/2) /* 289/16 */;
  top: (6.8125rem/2) /* 109/16 */;
}

.dian3 {
  left: (8.875rem/2) /* 142/16 */;
  top: (14.0625rem/2) /* 225/16 */;
}

.dian4 {
  left: (21.3125rem/2) /* 341/16 */;
  top: (11rem/2) /* 176/16 */;
}

.dian5 {
  left: (8.875rem/2) /* 142/16 */;
  top: (17.875rem/2) /* 286/16 */;
}

.dian6 {
  left: (29.75rem/2) /* 476/16 */;
  top: (21.8125rem/2) /* 349/16 */;
}

.dian7 {
  left: (31rem/2) /* 496/16 */;
  top: (13.5rem/2) /* 216/16 */;
}

.xtContent {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
}

.xtDotContent {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.xingtuSelected {
  background-size: 100% auto;
}

.xingtuInner {
  width: 100%;
  height: 100%;
  position: relative;
}

.dot {
  width: (3.125rem/2) /* 50/16 */;
  height: (3.125rem/2) /* 50/16 */;
  position: absolute;
}

.dotInner {
  width: 100%;
  height: 100%;
  .bg("./img/dot-right.png");
  transform-origin: 50% 50%;
}

.dotdotWrong {
  .bg("./img/dot-wrong.png");
  animation: dotdotWrongAction 1s infinite;
}

@keyframes dotdotWrongAction {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}

.dot1 {
  left: (7.0625rem/2) /* 113/16 */;
  top: (6.9rem/2) /* 127/16 */;
}

.dot2 {
  left: (13.6rem/2) /* 216/16 */;
  top: (7.9375rem/2) /* 127/16 */;
}

.dot3 {
  left: (15.9rem/2) /* 260/16 */;
  top: (10.8rem/2) /* 171/16 */;
}

.dot4 {
  left: (19.2rem/2) /* 305/16 */;
  top: (13.6rem/2) /* 222/16 */;
}

.dot5 {
  left: (18.9rem/2) /* 305/16 */;
  top: (17.8rem/2) /* 286/16 */;
}

.dot6 {
  left: (25.8rem/2) /* 416/16 */;
  top: (20.1rem/2) /* 323/16 */;
}

.dot7 {
  left: (28.5rem/2) /* 458/16 */;
  top: (15.7rem/2) /* 255/16 */;
}

.wdot {
  width: (3.125rem/2) /* 50/16 */;
  height: (3.125rem/2) /* 50/16 */;
  position: absolute;
}

.wdot1 {
  left: (7.0625rem/2) /* 113/16 */;
  top: (6.9rem/2) /* 127/16 */;
}

.wdot2 {
  left: (13.6rem/2) /* 216/16 */;
  top: (7.9375rem/2) /* 127/16 */;
}

.wdot3 {
  left: (15.9rem/2) /* 260/16 */;
  top: (10.8rem/2) /* 171/16 */;
}

.wdot4 {
  left: (19.2rem/2) /* 305/16 */;
  top: (13.6rem/2) /* 222/16 */;
}

.wdot5 {
  left: (18.9rem/2) /* 305/16 */;
  top: (17.8rem/2) /* 286/16 */;
}

.wdot6 {
  left: (25.8rem/2) /* 416/16 */;
  top: (20.1rem/2) /* 323/16 */;
}

.wdot7 {
  left: (28.5rem/2) /* 458/16 */;
  top: (15.7rem/2) /* 255/16 */;
}

.makehaibaoBtn {
  width: (31.3125rem/2) /* 501/16 */;
  height: (12.5625rem/2) /* 201/16 */;
  position: absolute;
  left: 50%;
  margin-left: -(31.3125rem/4) /* 501/16 */;
  bottom: 8vh;
  .bg("./img/makehaibaoBtn.png");
  z-index: 10;
}

.listHaibaoWrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  z-index: 12;

  .datiTitle {
    width: 100vw;
    height: (8.75rem/2) /* 140/16 */;
    .bg("./img/datiTitle.png");
    margin-bottom: 4vh;
  }

  .daNum {
    width: 100%;
    height: 100%;
    .bg("./img/da0.png");
  }

  .daNum0 {
    background-image: url("./img/da0.png");
  }

  .daNum1 {
    background-image: url("./img/da1.png");
  }

  .daNum2 {
    background-image: url("./img/da2.png");
  }

  .daNum3 {
    background-image: url("./img/da3.png");
  }

  .daNum4 {
    background-image: url("./img/da4.png");
  }

  .daNum5 {
    background-image: url("./img/da5.png");
  }

  .daNum6 {
    background-image: url("./img/da6.png");
  }

  .daNum7 {
    background-image: url("./img/da7.png");
  }

  .daDescption {
    width: (36.3125rem/2) /* 581/16 */;
    height: (3.375rem/2) /* 54/16 */;
    .bg("./img/dtitle0.png");
    margin-bottom: 1.5vh;
  }

  .daDescption0 {
    background-image: url("./img/dtitle0.png");
  }

  .daDescption1 {
    background-image: url("./img/dtitle1.png");
  }

  .daDescption2 {
    background-image: url("./img/dtitle2.png");
  }
}

.haibaoWWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100vw;
}

.hbWrapper {
  width: 50vw;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.lbox {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px auto 0;
  width: (20.75rem/2) /* 332/16 */;
  height: (35.5625rem/2) /* 569/16 */;
  .bg("./img/listHaibaoBg.png");

  .wbox {
    width: (17.875rem/2) /* 286/16 */;
    height: (31.875rem/2) /* 510/16 */;
    overflow: hidden;
    display: none;
    margin: 0 auto;

    .wboxInner {
      width: 100%;
      height: 100%;
      box-sizing: border-box;

      img {
        width: 100%;
      }
    }
  }

  .selected {
    display: block;
    .wboxInner {
    }
  }
}

.hbwBtn {
  width: (25.5rem/2) /* 408/16 */;
  height: (12.5625rem/2) /* 201/16 */;
  animation: huxiDong 1.5s infinite;
}

@keyframes huxiDong {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.92);
  }
  100% {
    transform: scale(1);
  }
}

.hbw1 {
  .bg("./img/hbBtn1.png");
}

.hbw2 {
  .bg("./img/hbBtn2.png");
}

.haibaomake {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  z-index: 12;
}

.makemake {
  width: (40.5rem/2) /* 648/16 */;
  height: 35rem;
  //.bg("./img/uploadbg.png");
  margin-bottom: 1vh;
}

.makemakeInner {
  width: (40.5rem/2) /* 648/16 */;
  height: 100%;
  position: relative;

  .mmTop {
    width: (40.5rem/2) /* 648/16 */;
    height: 100%;
    position: absolute;
    z-index: 2;
    .bg("./img/bg-bottom.png");
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }

  .mmBottom {
    width: (40.5rem/2) /* 648/16 */;
    height: 100%;
    .bg("./img/bg-top.png");
    background-position: 0 bottom;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }

  .line {
    width: 315px;
    height: 548px;
    position: absolute;
    background: linear-gradient(#006fbc, #00013a);
    border-radius: 13px;
    margin: 5px;
  }
}

#haibaoContainer {
  width: 285px;
  height: 518px;
  padding: 15px 15px 0;
  overflow: hidden;
}

.mhaibaoBtn {
  width: (34.25rem/2) /* 548/16 */;
  height: (12.625rem/2) /* 202/16 */;
  .bg("./img/schaibaoBtn.png");
}

.selfToast {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 10.8rem;
  padding: 0.75rem /* 12/16 */ 1rem;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 0.375rem /* 6/16 */;
  font-size: 1rem /* 16/16 */;
  color: #fff;
  text-align: center;
  z-index: 99;
}

.liuxingBox {
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;

  .lx {
    position: absolute;
    opacity: 0;
  }

  .lx1 {
    width: (13.8125rem/2) /* 221/16 */;
    height: (9.1875rem/2) /* 147/16 */;
    .bg("./../page-kv/img/p1-liuxing0.png");
    left: (1.875rem/2) /* 30/16 */;
    top: (31.25rem/2) /* 500/16 */;
    animation: lx1dong 15s infinite linear;
  }

  .lx3 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./../page-kv/img/p1-liuxing1.png");
    left: 150px;
    top: 10px;
    animation: lx3dong 10s infinite linear;
  }

  .lx4 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./../page-kv/img/p1-liuxing1.png");
    left: 0;
    top: 400px;
    animation: lx5dong 18s infinite linear;
  }

  .lx6 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./../page-kv/img/p1-liuxing1.png");
    left: 150px;
    top: 650px;
    animation: lx3dong 12s infinite linear;
  }
}

@keyframes lx1dong {
  0% {
    transform: translate(-1000px, -700px);
    opacity: 0;
  }
  1% {
    transform: translate(-1000px, -700px);
    opacity: 1;
  }
  50% {
    transform: translate(750px, 600px);
    opacity: 1;
  }
  51% {
    transform: translate(750px, 600px);
    opacity: 0;
  }
  100% {
    transform: translate(-1000px, -700px);
    opacity: 0;
  }
}

@keyframes lx3dong {
  0% {
    transform: translate(-900px, -700px);
    opacity: 0;
  }
  30% {
    transform: translate(-900px, -700px);
    opacity: 1;
  }
  50% {
    transform: translate(1000px, 800px);
    opacity: 1;
  }
  51% {
    transform: translate(1000px, 800px);
    opacity: 0;
  }
  100% {
    transform: translate(-900px, -700px);
    opacity: 0;
  }
}

@keyframes lx5dong {
  0% {
    transform: translate(-900px, -500px);
    opacity: 0;
  }
  60% {
    transform: translate(-900px, -500px);
    opacity: 1;
  }
  87% {
    transform: translate(800px, 800px);
    opacity: 1;
  }
  88% {
    transform: translate(800px, 800px);
    opacity: 0;
  }
  100% {
    transform: translate(-900px, -500px);
    opacity: 0;
  }
}

.xingkongBox {
  width: 100vw;
  height: 42.9375rem /* 1374/16 */;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;

  .xk7 {
    top: 7.5rem;
    left: 0rem;
  }

  .xk8 {
    left: 2rem;
  }
}

.luodipage {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  z-index: 40;
}

.myhaibaoLayer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .hdMyHaibao {
    width: (33.4rem/2) /* 531/16 */;
    background: rgba(0, 255, 255, 0.5);
    padding: 5px;
  }

  img {
    width: (33.1875rem/2) /* 531/16 */;
    border: 1px solid #00ffff;
  }
}

.saveTip {
  .bg("./img/savetip.png");
  width: (31.4375rem/2) /* 503/16 */;
  height: (1.5625rem/2) /* 25/16 */;
  margin: 10px auto 0;
}

.btnBox {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  justify-content: center;
  padding-top: 10px;
}

.obtn {
  width: (24rem/2) /* 408/16 */;
  height: (12rem/2) /* 201/16 */;
}

.replayBtn {
  .bg("./img/replayBtn.png");
}

.shareBtn {
  .bg("./img/shareBtn.png");
}

.sharelayer {
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
}

.shareLayerTip {
  width: (3.6875rem/2) /* 59/16 */;
  height: (27.3125rem/2) /* 437/16 */;
  .bg("./img/sharelayer.png");
  position: absolute;
  top: 25px;
  right: 15px;
}

.fly {
  animation: flydong 1s infinite linear;
}

@keyframes flydong {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, -20px);
  }
}

@media only screen and (device-width: 414px) and (device-height: 736px) {
}
</style>



// WEBPACK FOOTER //
// src/pages/page-one/pageOne.vue